/**
 * Where an account's OWN jobs live in the URL space (DY2.6).
 *
 * A FixyBee can post jobs as the requester, so "the pages about my own jobs"
 * stopped being a synonym for `/client/*`. Every route in this app is namespaced
 * by the account's role — `ProtectedRoute` bounces anyone who leaves their own
 * half — so the same screen has two addresses and the caller has to pick the
 * one that matches who is signed in.
 *
 * One function rather than the same ternary in six components, because the six
 * were already drifting: the Dany widget navigated to `/client/jobs/:id` while
 * the notification bell picked by role, and a FixyBee publishing a job hit the
 * first one and was thrown out of the page they had just created.
 *
 * The job DETAIL route is shared with the browsing FixyBee — `/provider/jobs/:id`
 * is where a quote is sent from, and it is also where a provider-owner reviews
 * the quotes they received. `JobDetail` tells the two apart by ownership, which
 * is the same question the server answers.
 */
export function ownerNamespace(role) {
  return role === "provider" ? "provider" : "client";
}

/** The list of jobs this account posted itself. */
export function ownJobsPath(role) {
  return role === "provider" ? "/provider/requests" : "/client/jobs";
}

/** The form that posts a new one. */
export function newJobPath(role) {
  return role === "provider" ? "/provider/requests/new" : "/client/jobs/new";
}

/** One job, on the side of the marketplace this account reads it from. */
export function jobDetailPath(role, jobId) {
  return `/${ownerNamespace(role)}/jobs/${jobId}`;
}

/** The form that edits one of their own open jobs (T19 F3). */
export function editJobPath(role, jobId) {
  return `${jobDetailPath(role, jobId)}/edit`;
}

/** Their message threads. */
export function messagesPath(role) {
  return role === "provider" ? "/provider/messages" : "/client/messages";
}
